import assemble from '@src/common/lang/assemble'

export default {
  /**
   * Avue组件库内置的国际化配置 ----START
   * 1.如下可对avue的内置国际化配置进行自定义设置,只允许修改对应的value值,key值不能修改,否则avue不能识别,当配置国际化时仍然会使用其源码内置的配置项
   * 2.具体各项对应的英文可在 ./en.js中查看
   * 3.目前avue暂支持部分中英文,更多语言请登录官网查看语言包更新方式
   * */
  common: {
    condition: '条件',
    display: '显示',
    hide: '隐藏',
  },
  tip: {
    select: '请选择',
    input: '请输入',
  },
  date: {
    start: '开始日期',
    end: '结束日期',
    tip: '至',
    year: '年',
    month: '月',
    hours: '小时',
    t: '今日',
    y: '昨日',
    n: '近7天',
    a: '全部',
  },
  crud: {
    filter: {
      addBtn: '新增条件',
      clearBtn: '清空数据',
      resetBtn: '清空条件',
      cancelBtn: '取 消',
      submitBtn: '确 定',
    },
    tipStartTitle: '当前表格已选择',
    tipEndTitle: '项',
    editTitle: '编 辑',
    addTitle: '新 增',
    viewTitle: '查 看',
    filterTitle: '过滤条件',
    menu: '操作',
    addBtn: '新 增',
    showBtn: '显 隐',
    closeBtn: '关 闭',
    filterBtn: '过 滤',
    refreshBtn: '刷 新',
    printBtn: '打 印',
    excelBtn: '导 出',
    updateBtn: '保 存',
    cancelBtn: '取 消',
    columnBtn: '多 选',
    searchBtn: '查 询',
    emptyBtn: '重 置',
    menuBtn: '功 能',
    saveBtn: '保 存',
    viewBtn: '查 看',
    editBtn: '编 辑',
    delBtn: '删 除',
  },
  // 公共基础组件国际化资源配置
  /**
   * 该部分配置主要以公共基础组件为主,不包含业务基础组件
   * 涵盖范围如下
   * common-modules\src\components\common\
   * common-modules\src\components\error-page
   * common-modules\src\components\global
   * common-modules\src\views\home
   * common-modules\src\views\user
   */
  base: {
    placeholder: {
      username: '请输入账户名',
      password: '请输入密码',
      account: '请输入账号',
      name: '请输入姓名',
      phone: '请输入手机号码',
      email: '请输入邮箱',
      remark: '请输入备注',
      oldPwd: '请输入原密码',
      newPwd: '请输入新密码',
      confirmPwd: '请输入确认密码',
    },
    button: {
      backHome: '返回首页',
      start: '启动',
      close: '关闭',
      set: '设置',
      logout: '退出',
      confirm: '确定',
      reset: '重置',
      view: '查看',
      cancel: '取消',
      login: '登录',
      getSN: '获取序列号',
      copy: '复制',
      upload: '点击上传',
      save: '保存',
    },
    label: {
      sex: '性別',
      avatar: '头像上传',
      personalInfo: '个人信息',
      editPwd: '修改密码',
      account: '账号',
      name: '姓名',
      index: '序号',
      phone: '手机号码',
      email: '邮箱地址',
      remark: '备注',
      oldPwd: '原密码',
      newPwd: '新密码',
      confirmPwd: '确认密码',
      alarmName: '告警名称',
      alarmLevel: '告警等级',
      alarmTime: '告警时间',
      // licence.vue
      mac: 'MAC地址',
      sn: '系列号',
      empty: '暂无数据',
      publicKey: '公钥',
      uploadFile: '上传文件',
    },
    title: {
      warn: '提示',
      confirm: '操作确认',
      notify: '告警通知',
    },
    message: {
      tipsmenu: '您没有任何权限，请联系管理员！',
      tips403: '抱歉，你无权访问该页面',
      tips404: '抱歉，你访问的页面不存在',
      tips500: '抱歉，服务器出错了',
      fileExceed: '文件超出限制',
      sockettime: '您的任务【{taskName}】即将在{time}分钟后启动，是否立即启动？',
      socketnow: '您的任务【{taskName}】已到达计划启动时间，是否立即启动？',
      confirmOut: '您确定退出系统吗？',
      account: '请输入账号',
      name: '请输入姓名',
      sex: '请选择姓名',
      less50: '长度在 1 到 50 个字符',
      phone: '请输入手机号码',
      phoneCheck: '手机号码格式不正确',
      email: '请输入邮箱',
      emailCheck: '邮箱格式不正确',
      emailFormat: '邮箱前缀为 4 到 18 个字符',
      remark: '请输入备注信息',
      oldPwd: '请输入原密码',
      newPwd: '请输入新密码',
      password: '请输入密码',
      less20: '长度在 6 到 20 个字符',
      confirmPwd: '请输入确认密码',
      sameWithAccount: '新密码不能和账户名一致，请修改',
      editPwdSuccess: '密码修改成功',
      againPwd: '请再次输入密码',
      diffPwd: '两次输入密码不一致！',
      passwordCheck2: '密码格式错误，必须包含字母，数字，特殊字符中的两种或两种以上！',
      editSuccess: '修改成功',
      onlyLicence: '只能上传licence文件，且不超过500kb',
      noage: '年龄不能为空',
      errormac: '输入的MAC地址不正确',
      noip: '输入的IP地址不能为空',
      copySuccess: '复制成功',
      copyFailed: '复制失败',
      noPublickey: '公钥不能为空',
      errorFile: '文件格式不正确',
      startrecord: '开始录像',
      reorderror: '开始录像错误，错误码：{code}',
      stoprecord: '录像已停止,存放位置:{path}',
      localSnap: '本地抓拍成功,存放位置:{path}',
      localSnapfail: '本地抓拍失败,错误码:{result}',
      platsnapsucc: '平台抓拍成功',
      platsnapfail: '平台抓拍失败!(错误码:{result}',
      yunterr: '云台操作失败，错误码：{result}',
      selectdev: '请先选择摄像机',
      inputname: '请先输入名称',
      inputrightname: '请输入正确的名称',
      addpresucc: '添加预置位成功',
      addprefail: '添加预置位失败!错误码:{result}',
      updatepresucc: '修改预置位名称成功',
      updateprefail: '修改预置位失败',
      delpresucc: '删除预置位成功',
      delprefail: '删除预置位失败!{result}',
      playbackfail: '录像播放失败,错误码:{result}',
      downloadsucc: '录像下载任务启动成功,存储位置{downloadPath}',
      downloadfail: '录像下载任务启动失败',
      loginfail: '视频管理平台登录失败，请联系管理员！',
      offline: '设备不在线！',
      playfail: '播放失败',
      playsucc: '播放声音成功',
      stopvoice: '声音已经停止播放',
      raisevoice: '调节音量大小',
      loadingfail: '加载失败',
      uploadSuccess: '上传成功',
    },
  },
  /*
   * 国际化文本资源配置文件，配置规范如下：
   * 1、所有配置的key使用全小写配置，无论有几个单词，均使用全小写，建议每个key不超过两个单词
   * 2、每个模块使用一个大的对象，如system，表示系统公共文本资源配置，如login表示登录页面的国际化配置
   * 3、每个页面必须配置在对应模块下，如事件规则（eventrule）页面的国际化必须配置在事件中心模块（eventcontral）下
   * 4、每个页面必须按功能分类国际化资源配置，如页面分类如下：lable（普通文本）、placeholder（输入框的提示文本）、button（按钮文本）、message（提示消息文本）
   * 5、每个国际化资源配置建议不要超过4层，即最深的访问层级为：system.common.button.confirm
   */
  // 公共国际化资源配置
  system: {
    // 公共文本
    common: {
      // 公共按钮文本
      button: {
        confirm: '确定',
        cancel: '取消',
        query: '查询',
        clear: '重置',
        next: '下一步',
        previous: '上一步',
        save: '保存',
        add: '新增',
        edit: '编辑',
        delete: '删除',
        play: '播放',
      },
      // 公共消息
      message: {
        greet: '您好，',
        homepage: '首页',
        nocenter: '无中心',
        systemerror: '系统异常，请稍后再试',
        reqfullscreen: '进入全屏',
        exitfullscreen: '退出全屏',
      },
    },
    platform: {
      // name: '鲁南制药集团智慧园区平台',
      name: '优合智慧园区物业运维管理平台',
      version: '',
    },
    theme: {
      default: '默认主题',
      dark: '深色主题',
      light: '淡色主题',
      newDark: '新主题',
      custom: '自定义主题',
    },
    menu: {
      0: '首页',
      11: '综合态势',
      1101: '告警中心',
      110101: '历史告警',
      110102: '手动告警',
      1102: '联动管理',
      110201: '联动规则',
      12: '综合安防',
      1201: '视频监控',
      120101: '视频监控',
      120102: '录像计划',
      120103: '录像策略',
      1202: '告警中心',
      120201: '实时告警',
      120202: '告警记录',
      120203: '任务管理',
      1203: '视频巡逻',
      120301: '巡逻计划',
      120302: '巡逻任务',
      120303: '巡逻历史',
      120304: '实时巡逻',
      1204: '电子巡更',
      120401: '巡更计划',
      120402: '巡更记录',
      1205: '周界管理',
      120501: '视频周界',
      120601: '工单管理',
      13: '通行管理',
      1301: '人员管理',
      130101: '人员名单管理',
      130102: '人员布控',
      130103: '人员研判',
      130104: '人员信息',
      130105: '车间记录',
      1302: '车辆管理',
      130201: '车辆名单管理',
      130202: '车辆布控',
      130203: '车辆研判',
      130204: '测速配置',
      130205: '超速记录',
      130206: '车辆审批记录',
      130301: '识别中心',
      130302: '识别记录',
      1304: '访客预约',
      130401: '预约记录',
      14: '消防管理',
      1401: '资产管理',
      1402: '资产归领管理',
      1403: '资产巡检',
      1404: '巡检记录',
      1501: '联动管理',
      150101: '联动规则',
      150102: '联动日志',
      1502: '预案管理',
      150201: '预案配置',
      150202: '预案执行',
      150203: '预案记录',
      1601: '设施管理',
      160101: '设备接入',
      160102: '设备列表',
      160103: '摄像机组管理',
      160104: '事件配置',
      17: '系统管理',
      1701: '账户管理',
      1702: '角色管理',
      1703: '工作组管理',
      1704: '区域管理',
      1705: '日志管理',
      1706: '系统参数设置',
      1707: '保卫换岗记录',
      190102: '主题配置',
      190103: '表格配置',
      190104: '可视化图表配置',
    },
    video: {
      planConfig: {
        Mon: '周一',
        Tues: '周二',
        Wed: '周三',
        Thur: '周四',
        Fri: '周五',
        Sat: '周六',
        Sun: '周七',
      },
      // 收藏夹
      bookmark: {
        ability: '功能选择',
        add: '新建收藏夹',
        edit: '编辑文件夹',
        play: '播放实时视频',
        bookmarkName: '收藏夹名',
        ordinary: '普通',
        car: '车辆识别',
        person: '人脸识别',
        tips: '请输入文件夹名称',
      },
    },
  },
  // 登录页面国际化资源配置
  login: {
    label: {},
    placeholder: {
      username: '请输入用户名',
      password: '请输入密码',
    },
    button: {
      submit: '登录',
    },
    message: {},
  },
  home: {
    label: {
      apptitle: '个人快捷面板',
      profile: '个人中心',
      theme: '切换主题',
      language: '切换语言',
      homepage: '用户首页',
    },
    placeholder: {},
    button: {
      logout: '退出登录',
    },
    message: {
      removeapp: '点击从快捷面板中移除',
      addapp: '点击加入快捷面板',
    },
  },
  // 公共业务组件国际化资源配置
  /**
   * 涵盖范围： bussines-modules\components\
   */
  business: {
    button: {
      capture: '查看抓拍',
      clip: '裁剪',
      clearClip: '清除裁剪',
      zoom: '放大',
      fastCm: '快速布控',
    },
    label: {},
    placeholder: {
      keyword: '请输入关键字进行检索',
    },
    message: {
      queryFailed: '查询失败',
      offline: '设备不在线',
      loadData: '数据加载中...',
      nodata: '暂无数据',
    },
    title: {
      areaDevice: '区域设备信息',
    },
  },
  ...assemble.zh,
}
